import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { showConfirmationModal } from "../redux-state/features/global-state/globalStateSlice";
import DeliveryStatus from "../shared-components/delivery-status";
import OrderDetails from "./orderDetails";
import {
  clearOBJ,
  closeObjModal,
  SetOrderStatus,
} from "../redux-state/features/orderState";
const ViewOrderItemsModal = ({}) => {
  const { obj, showObjModal, orderStatus } = useSelector(
    (state) => state.orderState
  );

  const dispatch = useDispatch();

  const HandleCancel = () => {
    dispatch(closeObjModal());
    dispatch(clearOBJ());
    dispatch(SetOrderStatus(""));
  };
  return (
    <>
      <Modal show={showObjModal} onHide={HandleCancel} scrollable size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "15px" }}>تفاصيل الطلب </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <p className="text-decoration-underline">حالة الطلب </p>
            <DeliveryStatus status={orderStatus} />
            <p className="text-decoration-underline">محتويات الطلب </p>
            {<OrderDetails data={obj} />}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={HandleCancel}>
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewOrderItemsModal;
